export const getOrtografiaInvalidReasonMessage = (reason) => {
  const errorMessages = {
    TOO_SHORT: "Troppo corta",
    NO_CENTER: "Usa la lettera al centro",
    ALREADY_FOUND: "Già trovata",
    NOT_IN_LIST: "Non è nell'elenco",
  };
  return errorMessages[reason] || "Errore durante l'invio";
};
